editMessengerFromVariableController.$inject = ['$scope', '$uibModalInstance', 'controllerParams'];
export function editMessengerFromVariableController($scope, $uibModalInstance, controllerParams) {

  $scope.submit = submit;
  $scope.cancel = cancel;

  init();

  function submit() {
    if ($scope.data.variable_origin !== 'url') {
      delete $scope.data.origin_url;
    }
    $uibModalInstance.close($scope.data);
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }

  function init() {
    $scope.data = {
      'input_variable': controllerParams.input_variable,
      'variable_origin': controllerParams.variable_origin,
      'origin_url': controllerParams.origin_url,
    };
    $scope.title = controllerParams.title;
  }

}
